import { topicsOpt } from "../options";

function displayTopics(topics) {
    let topicsText = "";

    topics.map((element) => {
        let newElement = {};
        newElement = topicsOpt.find((item) => item.id == element.topic_id);
        if (topics.length > 1) topicsText += `${newElement.text},`;
        else topicsText = newElement.text;
    });

    return topicsText;
}

function checkCount(count) {
    if (count) return count;
    return 0;
}

function displayCounselingWay(type) {
    if (type == null || type === "") return "";
    if (type == 1 || type === "1" || type === "in-person") return "In-person";
    if (type == 2 || type === "2" || type === "by-phone") return "By-phone";
    return type;
}

function getOutsideTownshipFlag(v) {
    const outside = v.outside_township;
    if (outside != null && typeof outside !== "object") return outside;
    if (v.outside_tsp != null) return v.outside_tsp;
    if (outside != null && typeof outside === "object") return 2;
    return null;
}

function displayOutsideTownship(v) {
    const flag = getOutsideTownshipFlag(v);
    if (flag == 2 || flag === "2") return "Yes";
    if (flag == 1 || flag === "1") return "No";
    return "";
}

function displayOutsideTownshipName(v) {
    const flag = getOutsideTownshipFlag(v);
    if (!(flag == 2 || flag === "2")) return null;

    const outside = v.outside_township;
    if (outside && typeof outside === "object" && outside.name) {
        return outside.name;
    }
    if (v.outside_township_name) return v.outside_township_name;
    return null;
}

export function getCustomFields(v) {
    let newObj = {
        Date: v.date,
        "  Code": v.mdrtb_code,
        "  Year": v.mdrtb_year,
        "Mono-Poly":v.patient?(parseInt(v.patient.mdrtb_monopoly) == 2 ? "Yes" : parseInt(v.patient.mdrtb_monopoly) == 3 ? "SG" : parseInt(v.patient.mdrtb_monopoly) == 4 ? "MGY" : 'No'):'',
        Township: v.township.name,
        Township_Code:v.township.short_code,
        "Township Group ": parseInt(v.township.township_group_id) == 1 ? "MDR 1 " : parseInt(v.township.township_group_id) == 2 ? "MDR 2" : '',
        Phone: v.phone,
        "Counseling Way": displayCounselingWay(v.type),
        "Outside Township": displayOutsideTownship(v),
        "Outside Township Name": displayOutsideTownshipName(v),
        Topics: displayTopics(v.topics),
        "Household members less than 5": checkCount(v.less_than_5_count),
        "Household members between 5 and 14": checkCount(
            v.between_5_and_14_count,
        ),
        "Household members greater than 15": checkCount(v.greate_than_15),
    };
    return newObj;
}